<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="epigraph"><span>God, how the dead men</span></p>
<p class="center"><span>Grin by the wall,</span></p>
<p class="center"><span>Watching the fun</span></p>
<p class="center"><span>Of the Victory Ball.</span></p>
<p class="center"><span>—Alfred Noyes,</span></p>
<p class="center"><span><i>A Victory Dance</i></span></p>
<p class="center" style="margin-top:20px;"><span>Evil … has infinite forms.</span></p>
<p class="center"><span>—Blaise Pascal,</span></p>
<p class="center"><span><i>Pensees</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-epigraph.vue?7ed204fd